import React, { memo, useState } from "react";
import { Box, Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ShipIcon, NavigationAidIcon } from "theme/icons";
import { SystemConstant, AppConstant } from "const";
import { useSelector } from "react-redux";
import FishingShipListDialog from "./FishingShipListDialog";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getShipTypeColor } from "utils";

const LayerCountShip = () => {
  const classes = useStyles();
  const filterShipResult = useSelector(state => state.shipRedux.filterShipResult);
  const shipTypes = useSelector(state => state.shipRedux.shipTypes);
  const shipConditions = useSelector(state => state.shipRedux.shipConditions);

  const countByType = filterShipResult.reduce((acc, ship) => {
    const { ship_type } = ship;
    acc[ship_type] = (acc[ship_type] || 0) + 1;
    return acc;
  }, {});

  const countTypeArray = Object.entries(countByType)
    .map(([type, count]) => ({
      ship_type: parseInt(type),
      count: count,
    }))
    .sort((a, b) => b.count - a.count);

  const isDisplay = !(
    shipConditions.source_type_list.length === 1 &&
    shipConditions.source_type_list.includes(AppConstant.SOURCE_DATA.gstc)
  );

  return (
    <>
      <Accordion
        className={isDisplay ? classes.layerBottomRightCont : classes.hideLayer}
        sx={{
          ".MuiAccordionSummary-content": {
            margin: 0,
          },
        }}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{
            minHeight: "24px",
            height: "24px",
            padding: "0 0 0 8px",
            "&.Mui-expanded": {
              minHeight: "24px",
              height: "24px",
            },
          }}
        >
          <Typography variant="h6" className={classes.accordionSummary}>
            Số lượng tàu thuyền
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ "&.MuiAccordionDetails-root": { padding: 0 } }}>
          <Box>{`Tổng số lượng tàu [${filterShipResult?.length}]`}</Box>
          <Box component="section" className={classes.scrollArray}>
            {countTypeArray.map(item => (
              <Box className={classes.detail}>
                {item.ship_type === SystemConstant.SHIP_TYPE.NAVIGATION_AID ? (
                  <NavigationAidIcon className={classes.navigationIcon} />
                ) : (
                  <ShipIcon fillColor={getShipTypeColor(item.ship_type)} />
                )}
                {`[${item.count}] ${shipTypes.find(st => st.type === item.ship_type).name}`}
              </Box>
            ))}
          </Box>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default memo(LayerCountShip);

const useStyles = makeStyles(theme => ({
  hideLayer: {
    display: "none",
  },

  layerBottomRightCont: {
    position: "fixed",
    zIndex: 1000,
    bottom: 10,
    right: 12,
    borderRadius: "4px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #999999",
    background: "#ffffff",
    padding: "4px",
  },

  detail: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    margin: "2px 0",
    cursor: "pointer",
  },
  detailIcon: {
    width: "16px",
    height: "16px",
  },
  accordionSummary: {
    fontSize: "14px",
  },

  scrollArray: {
    maxHeight: "200px",
    overflow: "auto",
  },

  navigationIcon: {
    fill: "pink",
    padding: "3px",
    userSelect: "none",
    display: "inline-block",
    flexShrink: 0,
    transition: "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    fontSize: "24px",
  },
}));
